import { colorInRGBA } from "core/utils"
/**
 *
 * @param {*} properties
 * @returns {string} a background image string or null
 */
export function getBackgroundImage(properties) {
  const { backgroundImage, backgroundColor } = properties
  if (!backgroundImage) return null

  // When there's no background color we simply wrap in a url() function
  if (!backgroundColor || backgroundColor === "transparent")
    return `url(${backgroundImage})`

  const rgbColor = colorInRGBA(backgroundColor, 0.5)
  return `linear-gradient(${rgbColor}, ${rgbColor}), url(${backgroundImage})`
}
